import { MedicationTabs } from "@/components/patients/patient/profile/sections/medication-details/MedicationTabs";
import { getPatientMedicationsById } from "@/app/store/patient/patientSlice";
import { useAppDispatch, useAppSelector } from "@/app/store";
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { getItemSessionStorage } from "@/lib/utils";
import { ELocalStorageKeys } from "@/app/types/localStorage";
import { capitalize } from "@/lib/utils";
import medicationIcon from "@/assets/patients/medications/capsule.svg";
import { useTranslation } from "react-i18next";
import { SkeletonTable } from "@/components/shared/skeletons/SkeletonTable";
import { validateAuthToken } from "@/guards/validateAuthToken";
import { validateActiveUser } from "@/guards/validateActiveUser";

export const Route = createFileRoute(
  "/dashboard/patients/$id/medications/$medicationId",
)({
  beforeLoad: () => {
    validateAuthToken();
    validateActiveUser();
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { medicationId } = Route.useParams();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const patientId =
    useAppSelector((state) => state.connection.selectedConnectionId) ||
    getItemSessionStorage(ELocalStorageKeys.PATIENT);

  const {
    medications = [],
    medicationsStatus,
  } = useAppSelector((state) => state.patient);

  useEffect(() => {
    if (!patientId) return;

    dispatch(getPatientMedicationsById(patientId)); // id real
  }, [dispatch, patientId]);

  if (medicationsStatus === "idle" || medicationsStatus === "loading") {
    return <SkeletonTable />;
  }

  if (medicationsStatus === "failed") {
    return <Navigate to="/dashboard/error/generic-error" />;
  }

  const medication = medications.find(
    (medication) => medication.id === medicationId,
  );

  if (!medication) {
    return <Navigate to="/dashboard/error/generic-error" />;
  }
  return (
    <div className="mb-8 max-w-7xl mx-auto">
      <div className="flex flex-col gap-4 mb-6">
        <div className="flex items-center gap-4">
          <img src={medicationIcon} alt="Medication icon" />
          <h1 className="text-2xl font-bold">
            {capitalize(medication.name)}
            {medication.dosage.amount
              ? ` ${medication.dosage.amount} ${medication.dosage.unit.toLowerCase()}`
              : ""}
            {medication.type
              ? `, ${capitalize(medication.type.toLowerCase())}`
              : ""}
          </h1>
        </div>
        <p>{t("patients.patient.profile.medication_details.subtitle")} </p>
      </div>

      <MedicationTabs medication={medication} />
    </div>
  );
}
